import PropTypes from 'prop-types';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
//
import Main from './main';
import Header from './header';

// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
  const nav = useBoolean();

  return (
    <>
      <Header onOpenNav={nav.onTrue} />
      <Main>{children}</Main>
    </>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
};
